module.exports = __webpack_public_path__ + "media/images/veridapt-logo-1126a9294336765459a107d9c1c65dae.svg";